import {SnapshotIn, types as t} from 'mobx-state-tree';

export const Character = t.model('Character', {
  id: t.identifier,
  name: t.maybeNull<any>(t.string),
  avatarUrl: t.maybeNull<any>(t.string),
});



export interface CharacterSnapshotIn extends SnapshotIn<typeof Character> {}
